import React, { useState, useContext } from "react";
import { Button, Typography } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { useDispatch, useSelector } from "react-redux";
import { useSnackbar } from "notistack";
import CircularProgress from "@mui/material/CircularProgress";
import { AuthContext } from "../../context/AuthContext";
import { baseUrl } from "../../baseUrl";

const DeleteDoctor = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [handler, setHandler] = useState(false);
  const auth = useContext(AuthContext);
  const dispatch = useDispatch();

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const deleteHandler = async (event) => {
    try {
      setIsLoading(true);
      const response = await fetch(baseUrl+"/api/v1/laboratorys/delete-doctor", {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          authorization: auth.token,
        },
        body: JSON.stringify({
          id: props.id,
        }),
      });
      const responseData = await response.json();
      if (!response.ok) {
        throw new Error(responseData.message);
      } else {
        enqueueSnackbar(responseData.message.message, { variant: "success" });
      }
      setIsLoading(false);
      dispatch({
        type: "update_doctor_table",
      });
    } catch (err) {
      setIsLoading(false);
      err && enqueueSnackbar(err.message, { variant: "error" });
    }
    props.close();
  };

  if (isLoading) {
    return (
      <div style={{ justifyContent: "center", display: "flex" }}>
        <CircularProgress color="inherit" />
      </div>
    );
  }
  return (
    <div>
      <Typography variant="h6" component="h2">
        هشدار
      </Typography>
      <Typography id="modal-modal-description" sx={{ mt: 2 }}>
        آیا مطمئنید می خواهید این پزشک را حذف کنید ؟
      </Typography>
      <Grid container spacing={3} sx={{ mt: 2 }}>
        <Grid xs={6}>
          <Button
            fullWidth
            color="error"
            variant="contained"
            onClick={deleteHandler}
          >
            بله
          </Button>
        </Grid>
        <Grid xs={6}>
          <Button
            fullWidth
            color="primary"
            variant="contained"
            onClick={props.close}
          >
            خیر
          </Button>
        </Grid>
      </Grid>
    </div>
  );
};

export default DeleteDoctor;
